module.exports = __webpack_public_path__ + "img/del.b65b2d83.png";